import { useLang } from 'hooks/lang';

import { actions, ProjectFile } from 'entities';

import { Button, Card, IconButton, LabeledInput, Modal, overlayEscape } from 'components/Blocks';
import { FileUpIcon, PencilIcon } from 'components/Icons';
import { useState } from 'react';
import { useProjectProfile } from '../../context';

interface RenameTaskFileButtonProps {
  file: ProjectFile;
}

export const MIN_FILE_NAME_LENGTH = 3;

export function RenameFileButton({ file }: RenameTaskFileButtonProps) {
  const { t } = useLang();
  const [name, setName] = useState(file.name);

  const { updateProject } = useProjectProfile();

  const nameOk = name.trim() !== file.name && name.trim().length > MIN_FILE_NAME_LENGTH;

  const changeName = actions.projects.renameProjectFile.use({
    params: {
      name,
      fileId: file.id,
      projectId: file.projectId,
    },

    onSuccess: () => {
      updateProject((old) => ({
        ...old,
        files: old.files.map((f) => ({ ...f, name: f.id === file.id ? name : f.name })),
      }));

      overlayEscape();
    },
  });

  return (
    <Modal
      title={t('rename-file?')}
      width="min(90vw, 560px)"
      trigger={
        <IconButton tooltipContent={t('rename')}>
          <PencilIcon size={14} />
        </IconButton>
      }
    >
      <Card flow="column" alignItems="center" className="text-primary" gap="3">
        <FileUpIcon size={36} />

        <span>{file.name}</span>

        <span className="text-xs text-foreground">{file.filename}</span>
      </Card>

      <LabeledInput value={name || file.name} onChangeDirect={setName} label={t('new-name')} />

      <Button disabled={!nameOk} {...changeName.buttonProps}>
        <PencilIcon />
        {t('change')}
      </Button>
    </Modal>
  );
}
